/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type CustomerNominatedAccountHistoryPaginatedProperty =
  typeof CustomerNominatedAccountHistoryPaginatedProperty[keyof typeof CustomerNominatedAccountHistoryPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerNominatedAccountHistoryPaginatedProperty = {
  CREATED_AT: 'CREATED_AT',
} as const;
